import React from 'react';
import styled from '@emotion/styled';
import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import State from '~Types/state';
import * as actions from '../../../actions';
import _ from 'lodash';
import { User } from '~Types';
import { useBridgeApi, useI18n, useLogger } from '~Hooks';
import { Button } from '~Styles';
import { useStorage } from '~Components/Storage';
import { removeDeviceToken, removeDeviceTokenVariables } from './__queries__';
import { useDeviceHandler } from '~Components/DeviceProvider';

const REMOVE_DEVICE_TOKEN = gql`
  mutation removeDeviceToken($token: String!) {
    removeDeviceToken(token: $token) {
      success
      message
    }
  }
`;

const LogoutLinkContainer = styled(Button)`
  background-color: var(--colorUIRed);
`;

const LogoutLink = styled(Link)`
  display: block;
  text-align: center;
  color: #fff;
  text-decoration: none;
`;

interface Props {
  setToken: (token: string | null) => void;
  deviceId: string;
  setUser: (user: User | null) => void;
}

const Logout: React.FunctionComponent<Props> = ({ setToken, deviceId, setUser }) => {
  const { i18n } = useI18n();
  const bridgeApi = useBridgeApi();
  const deviceHandler = useDeviceHandler();
  const reloadLogger = useLogger('mount');
  const logger = useLogger('logout');
  const [, updateStorage] = useStorage();
  const [removeDeviceToken] = useMutation<removeDeviceToken, removeDeviceTokenVariables>(
    REMOVE_DEVICE_TOKEN,
  );

  const logout = async () => {
    if (deviceId) {
      removeDeviceToken({
        variables: {
          token: deviceId,
        },
      });
    }

    logger.info('LOGGING OUT: Clearing tax compliance device fields from storage');

    if (deviceHandler?.activeDevice) {
      await deviceHandler.unclaim(deviceHandler?.activeDevice?.id);
    }

    updateStorage({
      taxComplianceDeviceId: null,
      taxComplianceDeviceName: null,
      taxComplianceCorporateId: null,
      taxComplianceProductionNumber: null,
      taxComplianceControlUnitSerial: null,
      deviceId: null,
    });

    setToken(null);
    setUser(null);
    window.postMessageBridge({
      setGalaxyToken: false,
      galaxyToken: '',
    });
    window.postMessageReact('authToken:');

    reloadLogger.info('Location reload: logout');

    setTimeout(() => {
      bridgeApi.reload();

      window.location.reload();
    }, 500);
  };

  return (
    <LogoutLinkContainer>
      <LogoutLink to="/" onClick={logout}>
        {i18n('Menu.Logout')}
      </LogoutLink>
    </LogoutLinkContainer>
  );
};
const mapStateToProps = (state: State) => ({
  deviceId: state.deviceId,
});

const mapDispatchToProps = {
  setUser: actions.setUser,
  setToken: actions.setToken,
};

export default _.flowRight(connect(mapStateToProps, mapDispatchToProps))(Logout);
